import { read, utils } from 'xlsx';

export const xlsxParser = <T>(data: ArrayBuffer): T[] => {
  const workbook = read(data, { type: 'array' });
  const firstSheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[firstSheetName];
  return utils.sheet_to_json<T>(worksheet);
};
